import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { AdministrationComponent } from './administration.component';
import { AdministrationRoutingModule } from './administration-router.module';
import { AdminDialogsModule } from './admin-dialogs/admin-dialogs.module';
import { PermissionLocationsGuard } from './guards/permission.guard';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AdministrationRoutingModule,
    AdminDialogsModule,
    AdministrationComponent,
  ],
  providers: [PermissionLocationsGuard],
})
export class AdministrationModule {}
